v-container
  v-row
    v-col(cols="12" md="4")
      v-text-field(
        v-model="contact.name"
        :label="$t('authorization.authorizedContacts.name')"
      )
    v-col(cols="12" md="4")
      v-text-field(
        v-model="contact.relation"
        :label="$t('authorization.authorizedContacts.relation')"
      )
    v-col(cols="12" md="4")
      v-text-field(
        v-model="contact.phone"
        :label="$t('authorization.authorizedContacts.phone')"
        type="tel"
      )
